var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCancel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Cancel-Publish",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8,1 C4.14026562,1 1,4.14026562 1,8 C1,11.8597344 4.14026562,15 8,15 C11.8597344,15 15,11.8597344 15,8 C15,4.14026562 11.8597344,1 8,1 Z M8,13.25 C5.10525391,13.25 2.75,10.8947461 2.75,8 C2.75,6.89514844 3.08496094,5.85067188 3.72185156,4.95942969 L11.0405703,12.2781484 C10.1493281,12.9150391 9.10485156,13.25 8,13.25 Z M12.2781484,11.0405703 L4.95942969,3.72185156 C5.85067188,3.08496094 6.89514844,2.75 8,2.75 C10.8947461,2.75 13.25,5.10525391 13.25,8 C13.25,9.10485156 12.9150391,10.1493281 12.2781484,11.0405703 Z",
    id: "Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default __webpack_public_path__ + "static/media/cancel.23603df002a96c4663dc31c2f3a67746.svg";
export { ForwardRef as ReactComponent };